import { render, staticRenderFns } from "./comTable.vue?vue&type=template&id=b0c1e9b6&"
import script from "./comTable.vue?vue&type=script&lang=js&"
export * from "./comTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports